import React from 'react'

import styles from './Notification.module.scss'
import { NotificationItem } from './NotificationItem'
import { NotificationItem as NotificationItemType } from './types'

type Props = {
  notifications: NotificationItemType[]
  autoDeleteTime?: number
}

const Notification = (props: Props): JSX.Element => {
  return (
    <div className={styles['notification-container']}>
      {props.notifications?.map(notification => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          autoDeleteTime={props.autoDeleteTime}
        />
      ))}
    </div>
  )
}
Notification.defaultProps = {
  autoDeleteTime: 7000,
}

export default Notification
